import React, { useState, useEffect } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { CreateOrderModalList } from '../../../constants';

import { getDeliverOrders } from '../../../service/api/StaffOrder/apiStaffOrder';

const CreateOrder = ({ onSubmit, onCancel }) => {

    const [deliverOrdersData, setDeliverOrdersData] = useState([]);
    const [form, setForm] = useState({
        email: "",
        name: "",
        phone: "",
        deliveryDate: "",
        addressCity: "",
        addressDistrict: "",
        addressDetailed: "",
        furnitureCount: 0, // 預設至少一件
        weight: 0,
        hasFloorService: 0,
        isShipped: 0,
        status: 0,
        staffOrderID: "",
        files: [],
        sendEmail: false, // ✅ 新增欄位
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();

        // 文字欄位
        Object.keys(form).forEach(key => {
            if (key !== 'files' && key !== 'sendEmail') {
                formData.append(key, form[key]);
            }
        });

        // 圖片檔案
        form.files.forEach(file => formData.append('files', file));

        formData.append('sendEmail', form.sendEmail ? 1 : 0);
        onSubmit(formData);
        console.log(form);
        formData.forEach((file, key) => console.log(key, ':', file));
    };

    useEffect(() => {
        getDeliverOrders({type: 'afterToday'})
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setDeliverOrdersData(response.data.result);
                }
            });
    }, [])

    return (
        <form onSubmit={handleSubmit}>
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <h5 className="modal-title">新增訂單</h5>
                        <button className="btn-close" onClick={onCancel}></button>
                    </div>
                    <div className="custom-modal-body">
                        {/* 基本資訊 */}
                        {CreateOrderModalList.map(field => (
                            <div className="input-group mb-3" key={field.name}>
                                <span className="input-group-text">
                                    {field.label}
                                    {field.required && <span className="required-star">*</span>}
                                </span>
                                <input
                                    type={field.type}
                                    className="form-control"
                                    name={field.name}
                                    value={form[field.name]}
                                    onChange={handleChange}
                                    placeholder={field.placeholder || ""}
                                    required={field.required}
                                    pattern={field.pattern}
                                    title={field.title}
                                    max={field.max}
                                    min={field.min}
                                />
                            </div>
                        ))}

                        {/* 出貨狀態 */}
                        <div className="input-group mb-3">
                            <span className="input-group-text">寄送狀態</span>
                            <select
                                className="form-select"
                                value={form.isShipped ? "shipped" : "pending"}
                                onChange={e => setForm(prev => ({ ...prev, isShipped: e.target.value === "shipped" ? 1 : 0 }))}
                            >
                                <option value="pending">未送達</option>
                                <option value="shipped">已送達</option>
                            </select>
                        </div>

                        {/* 審核狀態 */}
                        <div className="input-group mb-3">
                            <span className="input-group-text">審核狀態</span>
                            <select
                                className="form-select"
                                value={form.status === 1 ? "approved" : form.status === 0 ? "unReviewed" : "rejected"}
                                onChange={e => setForm(prev => ({ ...prev, status: e.target.value === "approved" ? 1 : e.target.value === "unReviewed" ? 0 : 2 }))}
                            >
                                <option value="rejected">未通過</option>
                                <option value="unReviewed">未審核</option>
                                <option value="approved">已通過</option>
                            </select>
                        </div>

                        {/* 樓層服務 */}
                        <div className="input-group mb-3">
                            <span className="input-group-text">樓層服務</span>
                            <select
                                className="form-select"
                                value={Number(form.hasFloorService) ? 1 : 0}
                                onChange={e => { setForm(prev => ({ ...prev, hasFloorService: e.target.value })); console.log(e.target.value) }}
                            >
                                <option value="0">否</option>
                                <option value="1">是</option>
                            </select>
                        </div>

                        {/* 選擇送貨單 */}
                        <div className="input-group mb-3">
                            <span className="input-group-text">送貨單</span>
                            <select
                                className="form-select"
                                name="staffOrderID"
                                value={form.staffOrderID}
                                onChange={handleChange}
                            >
                                <option value="">-- 請選擇送貨單 --</option>
                                {deliverOrdersData.map(deliverOrder => (
                                    <option key={deliverOrder.id} value={deliverOrder.id}>
                                        ID:{deliverOrder.id} {deliverOrder.name} ({deliverOrder.plate})
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* ✅ 是否寄送 Email */}
                    <div className="custom-modal-footer">
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="sendEmail"
                                name="sendEmail"
                                checked={form.sendEmail}
                                value={form.sendEmail}
                                onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="sendEmail">
                                是否傳送 Email
                            </label>
                        </div>
                        <div className="d-flex gap-2">
                            <button className="btn btn-secondary" onClick={onCancel}>取消</button>
                            <button className="btn btn-gradient-primary" type="submit">儲存</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export { CreateOrder };
